import { Box, Button, TextField } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

export const FilteringZone = ({
    handleShowAdd,
    lngsltd,
    search,
    setSearch,
    handleClearFilters
}) => {
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="80%"
        >
            {/* Left Side */}
            <Box display="flex" alignItems="center" gap={2} width="70%">
                <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Search by UserEmail or Group"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    sx={{ flex: 1 }}   // Takes remaining width
                />

                <Button
                    variant="outlined"
                    color="error"
                    onClick={handleClearFilters}
                    sx={{ whiteSpace: "nowrap" }}
                >
                    {lngsltd["Clear Filters"]}
                </Button>
            </Box>

            {/* Right Side */}
            <Button
                variant="contained"
                color="primary"
                onClick={handleShowAdd}
                startIcon={<AddIcon />}
                sx={{ whiteSpace: "nowrap" }}
            >
                Add User Group
            </Button>
        </Box>
    );
};
